import * as Yup from 'yup';
import { DEFAULT_LANG, LANGUAGE_BY_DOMAIN } from '../../../utils/constants';

export function getDynamicFeatureCategoryFields() {
  let dynamicFields = {};
  LANGUAGE_BY_DOMAIN.forEach(item => {
    dynamicFields = {
      ...dynamicFields,
      [`category${item[1]}`]: '',
    };
  });
  return dynamicFields;
}

function getInitialFormData() {
  const dynamicFields = getDynamicFeatureCategoryFields();
  const initialFormData = {
    isMultiLang: 'false',
    ...dynamicFields,
  };

  return initialFormData;
}

export const featureCategoryInitialFormData = getInitialFormData();

export function featureCategoryValidationSchema(isMultiLangFlag) {
  let validationFields = {
    [`category${DEFAULT_LANG.value}`]: Yup.string()
      .min(3, 'Minimum of 3 characters required')
      .required(`Category(${DEFAULT_LANG.label}) is required!`),
  };

  LANGUAGE_BY_DOMAIN.filter(item => DEFAULT_LANG.value !== item[1]).forEach(([label, value]) => {
    if (isMultiLangFlag) {
      validationFields = {
        ...validationFields,
        [`category${value}`]: Yup.string()
          .min(3, 'Minimum of 3 characters required')
          .required(`Category(${label}) is required!`),
      };
    } else {
      validationFields = {
        ...validationFields,
        [`category${value}`]: Yup.string(),
      };
    }
  });

  return Yup.object().shape({
    isMultiLang: Yup.string(),
    ...validationFields,
  });
}
